import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  mutation deleteBasicAuthKey($token: String!, $key: String!) {
    deleteBasicAuthKey(token: $token, key: $key)
  }
`);
